const R = {
  STRUCTURED_SERVICE_ITEM: "STRUCTURED_SERVICE_ITEM",
  FREE_FORM_SERVICE_ITEM: "FREE_FORM_SERVICE_ITEM"
};
var T = /* @__PURE__ */ ((E) => (E.INTERPRETATION_EXACT = "INTERPRETATION_EXACT", E.INTERPRETATION_STARTS_AT = "INTERPRETATION_STARTS_AT", E.INTERPRETATION_RANGE = "INTERPRETATION_RANGE", E))(T || {});
export {
  T as RangeInterpretation,
  R as ServiceTypeEnum
};
